import {
  CODE_SUCCESS, CriteriaLevels,
  ERROR_MESSAGE,
  INDEX_DB_NAME,
  KEY,
  KEY_DS_DANH_MUC_TIEP_DON,
  RESPONSE_MESSAGE,
  TYPE,
} from "./Constant";
import {toast} from "react-toastify";
import {useEffect, useState} from "react";
import moment from "moment";
import Fuse, {IFuseOptions} from "fuse.js";
import {RESPONSE_STATUS_CODE} from "../auth/core/_consts";
import {COMPONENT_TYPE, VARIABLE} from "../component/generate-form/GenerateFormConfig";
import * as Yup from "yup";
import {formatDateDTO} from "./FormatUtils";
import {WfWorkflowsReq} from "../workflows/models/WfWorkflows";
import {updateWfWorkflows} from "../workflows/services/WfWorkflowsService";
import {getJsonGenerateForm} from "./ServicesUtils";
import {deleteIndexedDBItem, getDataFromIndexedDB, openDatabaseByName, saveDataToIndexedDB} from "./IndexedDB";
import {useIntl} from "react-intl";
import {columnNamesType} from "@oceantech/oceantech-ui";
import {IFormComponent} from "./models";

export const removeEventEnter = (e: any) => {
  if (e.key === KEY.ENTER) {
    e.preventDefault();
  }
};

export const formatDate = (data: number) => {
  return data < 10 ? `0${data}` : data;
};
export const RomanNumeralsConverter = (number: number) => {
  if (isNaN(number)) {
    return;
  }

  const romanNumerals: { value: number; numeral: string }[] = [
    { value: 1000, numeral: "M" },
    { value: 900, numeral: "CM" },
    { value: 500, numeral: "D" },
    { value: 400, numeral: "CD" },
    { value: 100, numeral: "C" },
    { value: 90, numeral: "XC" },
    { value: 50, numeral: "L" },
    { value: 40, numeral: "XL" },
    { value: 10, numeral: "X" },
    { value: 9, numeral: "IX" },
    { value: 5, numeral: "V" },
    { value: 4, numeral: "IV" },
    { value: 1, numeral: "I" },
  ];

  let result = "";
  for (const element of romanNumerals) {
    while (number >= element.value) {
      result += element.numeral;
      number -= element.value;
    }
  }

  return result;
};

export function generateSecureRandomId(length: number = 16) {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join(
    ""
  );
}

export const generateForm = async (codeAPI: string, setIsLoading?: (isLoading: boolean) => void) => {
  try {
    setIsLoading?.(true);
    const db = await openDatabaseByName(INDEX_DB_NAME.FORM_MODEL);
    let dataFieldAuto = await getDataFromIndexedDB(db, codeAPI, INDEX_DB_NAME.FORM_MODEL);

    if (dataFieldAuto) {
      return JSON.parse(dataFieldAuto) || {};
    } else {
      let res = await getJsonGenerateForm(codeAPI);
      if (res?.data?.code === CODE_SUCCESS) {
        dataFieldAuto = res?.data?.data;

        if (dataFieldAuto) {
          await saveDataToIndexedDB(db, `form-${codeAPI}`, dataFieldAuto, INDEX_DB_NAME.FORM_MODEL);
          return JSON.parse(dataFieldAuto);
        } else {
          toast.error(ERROR_MESSAGE);
          return {};
        }
      } else {
        toast.error(ERROR_MESSAGE);
      }
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error(ERROR_MESSAGE);
  } finally {
    setIsLoading?.(false);
  }
};

export const removeVietnameseTones = (str: string = "") => {
  str = str.replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, "a");
  str = str.replace(/[èéẹẻẽêềếệểễ]/g, "e");
  str = str.replace(/[ìíịỉĩ]/g, "i");
  str = str.replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, "o");
  str = str.replace(/[ùúụủũưừứựửữ]/g, "u");
  str = str.replace(/[ỳýỵỷỹ]/g, "y");
  str = str.replace(/đ/g, "d");

  str = str.replace(/[ÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ]/g, "A");
  str = str.replace(/[ÈÉẸẺẼÊỀẾỆỂỄ]/g, "E");
  str = str.replace(/[ÌÍỊỈĨ]/g, "I");
  str = str.replace(/[ÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ]/g, "O");
  str = str.replace(/[ÙÚỤỦŨƯỪỨỰỬỮ]/g, "U");
  str = str.replace(/[ỲÝỴỶỸ]/g, "Y");
  str = str.replace(/Đ/g, "D");

  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/[\u0300\u0301\u0303\u0309\u0323]/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/[\u02C6\u0306\u031B]/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư

  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, " ");
  str = str.trim();

  // Bỏ dấu câu, kí tự đặc biệt
  // eslint-disable-next-line no-useless-escape
  str = str.replace(
    /[!@%^*()+=<>/,.:;'"&#~$_`-{}|\\]/g,
    " "
  );
  return str;
};

export function customDebounce(func: (...args: any[]) => void, wait: number) {
  let timeout: ReturnType<typeof setTimeout>;
  return (...args: any[]) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}
export const flatArrayByChildrenName = (arr: any, childName: string) => {
  let result: any = [];

  arr.forEach((item: any) => {
    result.push(item);
    if (item[childName] && item[childName].length > 0) {
      result = result.concat(
        flatArrayByChildrenName(item[childName], childName)
      );
    }
  });

  return result;
};

export const handleConvertBirthdate = (data: any) => {
  if (data?.birthDate) {
    return moment(data?.birthDate).format("DD/MM/YYYY");
  } else if (data?.dobYear) {
    return data?.dobYear;
  } else if (data?.dobYear && data?.dobMonth) {
    return data?.dobMonth + "/" + data?.dobYear;
  }
};

export const handleConvertAddress = (data: any) => {
  if (!data) return "";

  let subDistrictName = data?.communeName || data?.subDistrictName;

  if (data?.provinceName) {
    return (
      (data?.address ? data?.address + ", " : "") +
      (subDistrictName ? subDistrictName + ", " : "") +
      (data?.districtName ? data?.districtName + ", " : "") +
      data?.provinceName
    );
  } else if (data?.contact) {
    return data?.contact;
  } else if (data?.address) {
    return data?.address;
  } else {
    return "";
  }
};

export const handleSearchByFuse = (
  listData: any[],
  textSearch: string,
  setListData: (data: any) => void,
  extraOptions?: IFuseOptions<any>
) => {
  const fuseOptions = {
    isCaseSensitive: false, //phân biệt chữ hoa chữ thường
    includeScore: true,
    shouldSort: true,
    includeMatches: false,
    findAllMatches: false,
    minMatchCharLength: 2, //kết quả trả về cả những phần tử khớp theo số lượng ký tự truyền vào
    // location: 0,
    // threshold: 1,
    // distance: 100,
    useExtendedSearch: true, //search nâng cao, phụ thuộc các dấu =, ", '
    ignoreLocation: true,
    ignoreFieldNorm: true,
    fieldNormWeight: 1,
    keys: ["code", "name"],
    ...extraOptions,
  };

  const fuse = new Fuse(listData, fuseOptions);
  if (textSearch !== "") {
    const lstServices = fuse.search(textSearch).map((ser: any) => {
      return ser?.item;
    });
    setListData(lstServices);
  } else {
    setListData(listData);
  }
};

export const checkTypeOfFile = (file: any) => {
  let isExcelFile =
    file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    file.type === "application/vnd.ms-excel" ||
    file.name.endsWith(".xlsx") ||
    file.name.endsWith(".xls");
  let isPDFFile = file.type === "application/pdf" || file.name.endsWith(".pdf");
  return { isExcelFile, isPDFFile };
};

export const generateValidationSchema = (data: any, formCode: string) => {
  const handleValidate = () => {
    let objValidation: any = {};
    const checkValidate = (lstData: any) => {
      let newLstData = lstData?.components?.filter(
        (item: any) => item.type !== COMPONENT_TYPE.BUTTON
      );

      newLstData?.forEach((value: any) => {
        if (value.validate?.required) {
          objValidation[value.key] = Yup.string()
            .required("Bắt buộc nhập")
            .nullable();
        } else if (
          value?.type === COMPONENT_TYPE.COLUMNS &&
          value?.columns &&
          value?.columns?.length
        ) {
          value?.columns?.forEach((lstValue: any) => {
            checkValidate(lstValue);
          });
        }
      });
    };
    checkValidate(data);
    return Yup.object({
      [formCode]: Yup.object(objValidation),
    });
  };

  return handleValidate();
};

export const generateInitValues = (data: any, formCode?: string) => {
  const handleValues = () => {
    let values: any = {};

    const checkValue = (lstData: any) => {
      let newLstData = lstData?.components?.filter(
        (item: any) => item.type !== COMPONENT_TYPE.BUTTON
      );
      newLstData?.forEach((data: any) => {
        switch (data.type) {
          case COMPONENT_TYPE.TEXTFIELD:
          case COMPONENT_TYPE.DATEPICKER:
          case COMPONENT_TYPE.TEXTAREA:
          case COMPONENT_TYPE.DAY:
          case COMPONENT_TYPE.TIME:
          case COMPONENT_TYPE.EMAIL:
          case COMPONENT_TYPE.PHONE:
            values[data.key] = data.defaultValue;
            break;
          case COMPONENT_TYPE.DATETIME:
            values[data.key] =
              data.defaultDate === "newDate"
                ? formatDateDTO(new Date())
                : data.defaultDate;
            break;
          case COMPONENT_TYPE.NUMBER:
            values[data.key] = Number.parseFloat(data.defaultValue) || "";
            break;
          case COMPONENT_TYPE.SELECT: {
            let fieldValue = (data.defaultValue && typeof data.defaultValue === "string")
              ? JSON.parse(data.defaultValue)
              : {
                  [data.key]: "",
                  [`${data.key}Id`]: "",
                  [`${data.key}Name`]: "",
                };

            if (typeof data.defaultValue === "number") {
              fieldValue = {[data.key]: data.defaultValue};
            }
            values = {
              ...values,
              ...fieldValue,
            };
            break;
          }
          case COMPONENT_TYPE.CHECKBOX:
          case COMPONENT_TYPE.RADIO:
            values[data.key] = (typeof data.defaultValue === "boolean" && data.defaultValue) ? "1" : "0";
            break;
          case COMPONENT_TYPE.COLUMNS:
            data?.columns?.forEach((lstData: any) => {
              checkValue(lstData);
            });
            break;
          default:
            break;
        }
      });
    };

    checkValue(data);
    console.log("values", values)
    return formCode ? { [formCode]: values } : values;
  };

  return handleValues();
};

export const changeWfStatus = async (
  tracker: string,
  wfWorkflowsReq: WfWorkflowsReq | undefined
) => {
  if (!wfWorkflowsReq) return;
  try {
    await updateWfWorkflows(tracker, wfWorkflowsReq);
  } catch (error) {
    console.error(error);
    toast.error(RESPONSE_MESSAGE.ERROR);
  }
};

export const generateDataByUrl = async (
  codeAPI: string,
  funcApi: () => Promise<any>,
  setIsLoading?: (isLoading: boolean) => void
) => {
  setIsLoading && setIsLoading(true);
  // try {
  //   const db = await openDatabaseByName(INDEX_DB_NAME.URL_DATA);
  //   let dataFieldAuto = await getDataFromIndexedDB(db, codeAPI, INDEX_DB_NAME.URL_DATA);

  //   if (dataFieldAuto) {
  //     return JSON.parse(dataFieldAuto) || {};
  //   } else {
  //     const res = await funcApi();
  //     if (res?.data?.code === CODE_SUCCESS) {
  //       const dataToStore = res.data.data;

  //       if (dataToStore) {
  //         await saveDataToIndexedDB(db, codeAPI, JSON.stringify(res), INDEX_DB_NAME.URL_DATA);
  //         return res;
  //       } else {
  //         toast.error(ERROR_MESSAGE);
  //         return {};
  //       }
  //     } else {
  //       toast.error(ERROR_MESSAGE);
  //     }
  //   }
  // } catch (error) {
  //   console.error("Error:", error);
  //   toast.error(ERROR_MESSAGE);
  // } finally {
  //   setIsLoading && setIsLoading(false);
  // }
};

export const generateSearchParams = (data: any, formCode?: string) => {
  const handleValues = () => {
    let searchParams: any = {};

    const checkValue = (lstData: any) => {
      let newLstData = lstData?.components?.filter(
        (item: any) => item.type !== COMPONENT_TYPE.BUTTON
      );
      newLstData?.forEach((data: any) => {
        switch (data.type) {
          case COMPONENT_TYPE.SELECT:
            if (data?.data?.headers?.length) {
              let ListKeySearch = {};
              data?.data?.headers?.length &&
                data?.data?.headers.forEach((item: any) => {
                  ListKeySearch = {
                    ...ListKeySearch,
                    [item.key]: item.value || "",
                  };
                });
              searchParams = {
                ...searchParams,
                [data?.key]: ListKeySearch,
              };
            }
            break;
          case COMPONENT_TYPE.COLUMNS:
            data?.columns?.forEach((lstData: any) => {
              checkValue(lstData);
            });
            break;
          default:
            break;
        }
      });
    };

    checkValue(data);
    return formCode ? { [formCode]: searchParams } : searchParams;
  };

  return handleValues();
};

export const generateSingleSearchParams = (component: any) => {
  let searchParams: any = {};

  if (component?.data?.headers?.length) {
    component?.data?.headers.forEach((item: any) => {
      searchParams = {
        ...searchParams,
        [item.key]: item.value || "",
      };
    });
  }

  return searchParams;
};

export const useDebounce = <T,>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const getFileExportName = (headers: any) => {
  const header = headers["content-disposition"];
  const fileName = header
    .split(";")
    .find((key: string) => key.includes("fileName"));

  if (!fileName) return "";

  return fileName.split("=")[1].trim();
};

export const getFieldPermissions = (model?: any): Record<string, "r" | "w"> => {
  const permissions: Record<string, "r" | "w"> = {};
  model?.fields?.forEach((field: string) => {
    const [name, permission] = field.split(":");
    permissions[name] = permission as "r" | "w";
  });
  return permissions;
};

export const uniqueArrayObject = (array: any[], key: string) => {
  if (!array.length) return [];

  return array.reduce((acc: any[], itemSource: any) => {
    if (!acc.some((uniqueItem: any) => itemSource[key] === uniqueItem[key])) {
      acc.push(itemSource);
    }
    return acc;
  }, []);
};

export const clearCategoriesCache = () => {
  deleteIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON).then(() => {});
};

export const roundToDecimalPlaces = (number: number, decimals?: number) => {
  const factor = Math.pow(10, decimals || 3);
  return Math.round(number * factor) / factor;
};

export const handleSuccessMessage = (type: 'create' | 'update' = 'create') => {
  const message = {
    create: TranslateMessage("TOAST.CREATE.SUCCESS"),
    update: TranslateMessage("TOAST.EDIT.SUCCESS"),
  }
  toast.success(message[type]);
}

export const isSuccessfulResponse = (code: number) => RESPONSE_STATUS_CODE.SUCCESS === code;

export function TranslateMessage(messageId?: string) {
  const intl = useIntl();
  return intl.formatMessage({ id: messageId || "" });
}

const handleMessageByResponseCode = (code?: number) => {
  switch (code) {
    case RESPONSE_STATUS_CODE.FORBIDDEN:
      toast.warning(TranslateMessage("TOAST.ERROR.FORBIDDEN"));
      return true;
    case RESPONSE_STATUS_CODE.METHOD_NOT_ALLOWED:
      toast.warning(TranslateMessage("TOAST.ERROR.METHOD_NOT_ALLOWED"));
      return true;
    case RESPONSE_STATUS_CODE.CONFLICT:
      toast.warning(TranslateMessage("TOAST.ERROR.CONFLICT"));
      return true;
    default:
      return false;
  }
};

export const handleThrowResponseMessage = (res: any) => {
  // todo: Trả ra message theo 2 loại message của response
  const { message, data, code } = res?.data;
  const singleMessageKey = VARIABLE.FUNCTION_CONSTANT.ERROR_MESSAGE;
  const multipleMessageKey = VARIABLE.FUNCTION_CONSTANT.MESSAGE;

  toast.clearWaitingQueue();
  if (handleMessageByResponseCode(code)) {
    return;
  }

  let firstObject = data?.[0];
  if (Object.keys(firstObject).includes(singleMessageKey)) {
    //case:  data = [{errorMessage: "..."}]
    toast.warning(
      firstObject[singleMessageKey] ? firstObject[singleMessageKey] : message //case:  data = [{errorMessage: null}]
    );
  } else if (Object.keys(firstObject).includes(multipleMessageKey)) {
    data.forEach((x: any) => {
      toast.warning(x.field + ": " + x[multipleMessageKey]);
    });
  } else {
    toast.error("GENERAL.ERROR");
  }
};

export const emptyfunc = () => {}

export const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, callBack: () => void) => {
  if (KEY.ENTER === event.key) {
    callBack()
  }
}

export const handleKeyUp = (event: React.ChangeEvent<HTMLInputElement>, callBack: () => void) => {
  if (!event.target.value) {
    callBack()
  }
}

export const getColumnsAlignByType = (column: columnNamesType) => {
  switch (column.type) {
    case TYPE.DATE:
      return "center";
    case TYPE.NUMBER:
      return "center";
    case TYPE.MONEY:
      return "right";
    case TYPE.TEXT:
      return "left";
    default:
      return "left";
  }
}

export const isHtmlTag = (tag: string): boolean  => {
  try {
    const el = document.createElement(tag);
    // Nếu browser tạo ra element có tagName khác "#document-fragment" hoặc "unknown" thì hợp lệ
    return el instanceof HTMLElement && el.tagName.toLowerCase() === tag.toLowerCase();
  } catch {
    return false;
  }
}

export const generateComponentLogics = (data: any, formCode?: string) => {
  const handleValues = () => {
    let logics: any = {};

    const checkValue = (lstData: any) => {
      let newLstData = lstData?.components?.filter(
        (item: any) => item.type !== COMPONENT_TYPE.BUTTON
      );
      newLstData?.forEach((data: IFormComponent) => {
        switch (data.type) {
          case COMPONENT_TYPE.TEXTFIELD:
          case COMPONENT_TYPE.DATEPICKER:
          case COMPONENT_TYPE.TEXTAREA:
          case COMPONENT_TYPE.DAY:
          case COMPONENT_TYPE.TIME:
          case COMPONENT_TYPE.EMAIL:
          case COMPONENT_TYPE.PHONE:
          case COMPONENT_TYPE.DATETIME:
          case COMPONENT_TYPE.NUMBER:
          case COMPONENT_TYPE.SELECT:
          case COMPONENT_TYPE.CHECKBOX:
          case COMPONENT_TYPE.RADIO:
            if (data.logic?.length) {
              logics[data.key] = data.logic;
            }
            break;
          case COMPONENT_TYPE.COLUMNS:
            data?.columns?.forEach((lstData: any) => {
              checkValue(lstData);
            });
            break;
          default:
            break;
        }
      });
    };

    checkValue(data);

    return formCode ? { [formCode]: logics } : logics;
  };

  return handleValues();
};

export const convertSubmitDataJsLogic = (logic: string) => {
  // logic format: result = (data = {}) => value
  // eslint-disable-next-line no-new-func
  const logicResult = new Function(`${logic} return result;`)();
  return logicResult();
}

export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const getCriteriaLevels = () => {
  const labels: Record<number, string> = {};
  const levelsArr: any[] = [];

  Object.values(CriteriaLevels)
    .filter(key => !isNaN(Number(key)))
    .forEach((v) => {
      labels[v as number] = `Mức ${v}`;
      levelsArr.push({id: v, name: `Mức ${v}`});
    });

  return {
    labels,
    array: levelsArr,
  };
}
